<ng-container>
  <div mat-dialog-title>
    <span>{{ title }}</span>

    <q9-dialog-close-button></q9-dialog-close-button>
  </div>

  <q9-content-loader [isLoading]="loading"></q9-content-loader>

  <div mat-dialog-content *ngIf="!loading">
    <q9-tags-select
      *ngIf="isTagsUpdate"
      [ngModel]="tags"
      (ngModelChange)="updateTags($event)"></q9-tags-select>

    <q9-select
      *ngIf="isOptimizationStatusUpdate"
      [label]="'SIDEBAR.STATUS' | translate"
      [(ngModel)]="optimizeStatus"
      [placeholder]="'RUBIC_CUBE.SELECT_OPTIMIZE_STATUS' | translate">
      <q9-option *ngFor="let status of optimizeStatuses" [value]="status">
        {{ status.value }}
      </q9-option>
    </q9-select>

    <q9-user-select
      *ngIf="isNodeAssigneeUpdate"
      [fetchFn]="fetchUsers.bind(this)"
      [formControl]="assigneeFormControl"
      (ngModelChange)="onSelectAssigneeHandler($event)"></q9-user-select>

    <q9-select
      *ngIf="isCNAUpdate && customNodeAttributes?.length"
      [label]="'RUBIC_CUBE.CUSTOM_NODE_FIELD' | translate"
      [placeholder]="'RUBIC_CUBE.SELECT_CUSTOM_NODE_FIELD' | translate"
      [(ngModel)]="customNodeAttribute"
      (selectionChange)="onSelectCustomNodeAttribute($event.value)">
      <q9-option *ngFor="let attribute of customNodeAttributes" [value]="attribute">
        <span class="truncate-text">{{ attribute.title }}</span>
      </q9-option>
    </q9-select>

    <ng-container *ngIf="!loadingCNADependencies && canUpdateCNA">
      <div *ngIf="isCNAUpdate && customNodeAttribute && customNodeAttributeControl">
        <custom-node-attribute
          [customNodeAttribute]="customNodeAttribute"
          [position]="0"
          [control]="customNodeAttributeControl"></custom-node-attribute>
      </div>
    </ng-container>

    <ng-container *ngIf="customNodeAttribute && !canUpdateCNA">
      <div class="text-center">{{'SIDEBAR.CNA_MASS_UPDATE_FORBIDDEN' | translate}}</div>
    </ng-container>

    <div *ngIf="isCNAUpdate && !customNodeAttributes?.length">
      <p class="text-center">{{ 'RUBIC_CUBE.NO_AVAILABLE_CUSTOM_NODE_FIELDS' | translate }}</p>
    </div>
  </div>

  <mat-dialog-actions class="actions-panel">
    <div *ngIf="!isDependency" class="items-count">
      {{ 'RUBIC_CUBE.NODES_TO_UPDATE' | translate: {nodesCount: nodesCount} }}
    </div>
    <div *ngIf="isDependency" class="items-count">
      {{ 'DA.NODES_TO_UPDATE' | translate: {nodesCount: nodesCount} }}
    </div>
    <div class="btn-container">
      <q9-secondary-button mat-dialog-close>
        {{ 'GENERAL.CANCEL_BTN' | translate }}
      </q9-secondary-button>

      <q9-primary-button (click)="confirm()" [disabled]="!isValid || !canUpdateCNA">
        {{ 'GENERAL.CONFIRM_BTN' | translate }}
      </q9-primary-button>
    </div>
  </mat-dialog-actions>
</ng-container>
